


















































































































import mixins from 'vue-typed-mixins'
import Navigation from '@/calendesk/mixins/Navigation'
import LoggedUserMenu from '@/calendesk/sections/navbar/components/LoggedUserMenu.vue'
import AdditionalPagesMenu from '@/calendesk/sections/navbar/components/AdditionalPagesMenu.vue'
import Page from '@/calendesk/models/DTO/Response/Page'
import DefaultButton from '@/calendesk/sections/section/components/DefaultButton.vue'
export default mixins(Navigation).extend({
  name: 'FlexibleNavbar1',
  methods: {
    buttonBackground (page: Page) {
      return {
        background:
          (this.currentPage && this.currentPage.uuid === page.uuid)
            ? this.draftConfiguration.wb_color_primary__color__
            : 'transparent'
      }
    },
    redirectFromNavbarLogo (): void {
      if (this.data.configuration.wb_redirect_logo__page_id__) {
        this.redirectToPageUuid(this.data.configuration.wb_redirect_logo__page_id__)
      } else {
        this.redirectToMainPage()
      }
    }
  },
  components: { DefaultButton, AdditionalPagesMenu, LoggedUserMenu }
})
